module.exports = __webpack_public_path__ + "static/progress2-57962c867d654d0a1ce4a47f0abf6758.png";